<template>
  <div :class="`ckbox ckbox-${color}`">
    <input
      v-if="value !== null && typeof checked === 'object'"
      :id="id"
      ref="input"
      type="checkbox"
      :checked="checkValue"
      :disabled="disabled"
      :name="name"
      :readonly="readonly"
      @click="setValue(value)"
    />
    <input
      v-else
      :id="id"
      ref="input"
      type="checkbox"
      :checked="model===true"
      :disabled="disabled"
      v-model="model"
      :name="name"
      :readonly="readonly"
      @click="setValue(value)"
    />
    <label :for="id" class="labelCheckbox">
      <slot></slot>
    </label>
  </div>
</template>

<script>
export default {
  inject: ["$validator"],
  name: "checkbox",
  props: {
    name: String,
    disabled: Boolean,
    readonly: Boolean,
    checked: [Array, Boolean],
    value: [Boolean, Number],
    color: {
      type: String,
      default: "primary",
      validator: function(value) {
        return (
          ["primary", "default", "danger", "info", "success"].indexOf(value) !==
          -1
        );
      }
    }
  },
  data() {
    return {
      id: null
    };
  },
  computed: {
    model: {
      get() {
        return this.checked;
      },
      set(check) {
        this.$emit("input", check);
      }
    }
  },
  methods: {
    setValue(value) {
      this.$emit("newValue", value);
    }
  },
  created() {
    this.id = Math.random()
      .toString(16)
      .slice(2);
  },
  mounted() {
    this.$el.value = this.value;
  },
  asyncComputed: {
    checkValue() {
      if (this.value && this.checked && typeof this.checked === "object") {
        const alternativaId = this.checked.filter(value => {
          if (typeof value === "object" && value) {
            return value.id === this.value;
          } else {
            return value === this.value;
          }
        });

        return alternativaId.length > 0 ? true : false;
      }

      return false;
    }
  }
};
</script>

<style>
.labelCheckbox {
  max-width: 90%;
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Forms/Checkbox.vue